import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'isExactMatch',
  standalone: true,
})
export class IsExactMatchPipe implements PipeTransform {
  transform(value: string, excludedValues: string[], notEqualCase: boolean = false): boolean {
    return !notEqualCase
      ? excludedValues.some((excludedValue) => excludedValue === value)
      : excludedValues.every((excludedValue) => excludedValue !== value)
  }
}
